<template>
  <Field symbol="name" class="col-span-7">
    <ZLabel for="name" class="flex justify-between items-center">
      {{ $t('category.label.category_name') }}
      <TranslationPopup v-if="category.id" type="category" :identifier="category.id!"></TranslationPopup>
    </ZLabel>
    <ZInput id="name" v-model="category.name" />
  </Field>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ZInput } from '@shadcn/components/ui/input';
import { ZLabel } from '@shadcn/components/ui/label';
import Field from '@ui/FormField.vue';
import CategoryData = App.Data.CategoryData;
import TranslationPopup from "@ui/TranslationPopup.vue";

export default defineComponent({
  components: {
    TranslationPopup,
    ZInput,
    ZLabel,
    Field,
  },

  props: {
    category: {
      type: Object as PropType<CategoryData>,
      required: true,
    },
  },
});
</script>
